module.exports = __webpack_public_path__ + "static/media/emojis2_13.d27b2a13.svg";